export enum UpdateSensorsBatchResponseKey {
  SUCCESSFUL = 'successful',
  FAILURE = 'failure',
}

export interface SensorPayloadModel {
  id: string;
  uid: string;
  name: string;
  room: string;
  usage: string;
  sensor_type: string;
  device_id: string;
  gateway_id: string | null;
  sensor_id: string;
  are_values_accumulated: boolean;
  can_data_be_fetched: boolean;
  available_tags: string[];
  tags: string[];
}

export interface SensorByProjectPayloadModel {
  id: string;
  name: string;
  room: string;
  usage: string;
}

export interface SensorUpdatePayloadModel {
  name?: string;
  room?: string;
  usage?: string;
  can_data_be_fetched?: boolean;
}

export interface SensorWithPasswordsParametersPayloadModel {
  max_digits: string;
  min_digits: string;
  valid_digits: string;
}

export interface SensorWithPasswordsPasswordPayloadModel {
  device_id: string;
  gateway_id: string;
  sensor_id: string;
  sensor_type: string;
  password: string;
}

export interface SensorWithPasswordsPayloadModel {
  device_name: string;
  device_type: string;
  device_parameters: SensorWithPasswordsParametersPayloadModel;
  sensor_passwords: SensorWithPasswordsPasswordPayloadModel[];
}

export interface SensorMetaPayload {
  total_pages: number;
  page_size: number;
  results: number;
  all_results: number;
}

export interface SensorLinksPayload {
  self: string;
  first: string;
  prev: string;
  next: string;
  last: string;
}

export interface SensorListResponsePayload {
  data: SensorPayloadModel[];
  meta: SensorMetaPayload;
  links: SensorLinksPayload;
}
export interface UpdateSensorsBatchItemPayload {
  id: string;
  visible: boolean;
}

interface UpdateSensorsBatchResponseItemPayload {
  name: string;
  room: string;
  sensor_id: string;
  sensor_type: string;
}

export interface UpdateSensorsBatchResponsePayload {
  data: {
    [UpdateSensorsBatchResponseKey.FAILURE]: UpdateSensorsBatchResponseItemPayload[];
    [UpdateSensorsBatchResponseKey.SUCCESSFUL]: UpdateSensorsBatchResponseItemPayload[];
  };
}
